import React, { useState } from "react";
import PropTypes from "prop-types";

import CheckBox from "../CheckBox/CheckBox";
import Button from "../Button/Button";
import styles from "./LocationAccessAcknowledgementModal.module.css";

const locationPinIcon = require("../../pages/Locations/imgs/location-pin-brand-refresh.svg");
const exitIcon = require("../Modal/imgs/exit-icon.svg");

const LocationAccessAcknowledgementModal = ({
  store,
  onContinue,
  onCancel
}) => {
  const [understood, setUnderstood] = useState(false);

  const handleContinue = () => {
    if (!understood) {
      return;
    }
    onContinue();
  };

  return (
    <div className={styles.container} data-part="location-access-acknowledgement">
      <div className={styles.headerRow}>
        <h2 id="location-access-modal-title" className={styles.heading}>
          Before You Order
        </h2>
        <button
          type="button"
          className={styles.closeButton}
          onClick={onCancel}
          aria-label="Close dialog"
        >
          <img src={exitIcon} alt="" className={styles.closeIcon} />
        </button>
      </div>
      <p className={`${styles.locationTitle} text-dark dark:text-white`}>
        <img src={locationPinIcon} alt="" className={styles.locationPin} />
        <span>{store?.name}</span>
      </p>
      <p className={`${styles.message} text-dark dark:text-white`}>
        {store?.locationAccessMessage}
      </p>
      <p className={`${styles.confirmCopy} text-darkElevationPrimary`}>
        Please confirm you can access this location for placement of your order.
      </p>
      <CheckBox
        label={<span className={styles.checkboxLabel}>I Understand</span>}
        isChecked={understood}
        onClick={() => setUnderstood(checked => !checked)}
        ariaLabel="I Understand"
      />
      <div className={styles.actions}>
        <Button
          label="Continue"
          handleSubmit={handleContinue}
          disabled={!understood}
          customContainerStyles={styles.continueButton}
        />
      </div>
    </div>
  );
};

LocationAccessAcknowledgementModal.propTypes = {
  store: PropTypes.shape({
    name: PropTypes.string,
    locationAccessMessage: PropTypes.string,
  }).isRequired,
  onContinue: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default LocationAccessAcknowledgementModal;
